export interface IGenericaDto {
  id?: string;
  descripcion?: string;
}

export class GenericaDto implements IGenericaDto {
  constructor(public id?: string, public descripcion?: string) {}
}
